<template>
    <div class="min-w-[300px] sm:max-w-[300px] h-min">
        <div class="wow fadeInUp" data-wow-delay=".15s" style="visibility: visible; animation-delay: 0.15s">
            <div class="grid grid-cols-3 gap-4 w-full p-2 mb-4">
                <div v-if="image_url"
                    class="rounded-full max-h-[60px] max-w-[60px] flex relative justify-center items-center overflow-hidden col-span-1">
                    <img :src="image_url" :alt="imageAlt" class="object-contain" />
                </div>
                <div class="flex flex-col justify-center col-span-2">
                    <p class="subtitle text-bold text-left" v-if="name">
                        {{ name }}
                    </p>
                    <p class="text-base text-[color:var(--medium-gray)] text-left" v-if="position">
                        {{ position }}
                    </p>
                </div>
            </div>
            <div class="w-full pb-5 px-2">
                <p class="text-left testimonial-description" v-if="quote">
                    {{ quote }}
                </p>
            </div>

        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        image_url: String,
        image_40: Boolean,
        quote: String,
        name: String,
        position: String,
        total: String,
    },
    computed: {
        imageAlt(): string {
            if (this.name && this.position) return `${this.name}, ${this.position}`;
            return this.name || '';
        },
    },
};
</script>
